import { useScrollToTop } from '@lair-finance/util'
import { useCloseMenuOnDisconnect } from '@/domains/header/hooks/useCloseMenuOnDisconnect.ts'
import { useCloseMenuOnResize } from '@/domains/header/hooks/useCloseMenuOnResize.ts'
import { useCloseMenuOnRouteChange } from '@/domains/header/hooks/useCloseMenuOnRouteChange.ts'
import { useSwitchChainFromQuery } from '@/shared/hooks/useSwitchChainFromQuery.ts'

export function useAppHooks() {
  useScrollToTop()
  useSwitchChainFromQuery()

  useCloseMenuOnDisconnect()
  useCloseMenuOnResize()
  useCloseMenuOnRouteChange()
}
